import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./pages/home";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/buscador" replace />} />

        <Route path="/buscador" element={<HomePage />} />
      </Routes>
    </Router>
  );
}

export default App;